export const reviseStringCode = {
  Campus: 'Tampa',
  campus: 'tampa',
  CAMPUS: 'TAMPA',
  MeeMee: "Cooper`s",
  MEEMEE: "COOPER`s",
  meemee: "cooper`s",

  // Beauty by Earth
  'Beauty by Earth': 'Elf skin Care',
  'BeautybyEarth': 'Elfskincare',
  'Beauty By Earth': 'Elf Skin Care',
  'beauty by earth': 'elf skin care',
  'Beauty Earth': 'Elf Skin Care',
  'beauty earth': 'elf skin care',
  'earth by beauty': 'elf skin care',
  "Earth's Beauty": "Elf's Skin Care",
  'beauty & earth': 'elf skin care',
  'beautybyearth': 'elfskincare',

  // Homespun Global
  'Homespun Global': 'The Natural Thread',
  'Homespun': 'NaturalThread',
  'LANE LINEN': 'NATURAL LINEN',
  'lane linen': 'natural linen',
  'Lane Linen': 'Natural Linen',
  'Casa Platino Sheets': 'Natural Green Sheets',
  'casa platino sheets': 'natural green sheets',
  'Casa Platino Sheets': 'Natural Green Sheets',
  'Casa Platino': 'Natural Thread',
  'casa platino': 'natural thread',
  'Casa Platino': 'Natural Thread',
};

export const reReviseStringCode = {
  Tampa: 'Campus',
  tampa: 'campus',
  TAMPA: 'CAMPUS',
  "Cooper`s": 'MeeMee',
  "COOPER`s": 'MEEMEE',
  "cooper`s": 'meemee',

  // Beauty by Earth
  'Elf skin Care': 'Beauty by Earth',
  'ElfskinCare': 'BeautybyEarth',
  'Elf Skin Care': 'Beauty By Earth',
  'elf skin care': 'beauty by earth',
  'Elf Skin Care': 'Beauty Earth',
  'elf skin care': 'beauty earth',
  'elf skin care': 'earth by beauty',
  "Elf's Skin Care": "Earth's Beauty",
  'elf skin care': 'beauty & earth',
  'elfskincare': 'beautybyearth',

  // Homespun Global
  'The Natural Thread': 'Homespun Global',
  'NaturalThread': 'Homespun',
  'NATURAL LINEN': 'LANE LINEN',
  'natural linen': 'lane linen',
  'Natural Linen': 'Lane Linen',
  'Natural Green Sheets': 'Casa Platino Sheets',
  'natural green sheets': 'casa platino sheets',
  'Natural Green Sheets': 'Casa Platino Sheets',
  'Natural Thread': 'Casa Platino',
  'natural thread': 'casa platino',
  'Natural Thread': 'Casa Platino',
};

export function replaceString(inputString = '', url = '') {
  const authToken = JSON.parse(localStorage.getItem('User')) || {};
  if (process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken?.email) > -1) {
    // Iterate over each key-value pair in reviseStringCode
    for (const [original, replacement] of Object.entries(reviseStringCode)) {
      // Construct a regex pattern with the 'g' flag to replace all occurrences
      const regex = new RegExp(original, 'g');
      // Replace occurrences of the original string with the replacement string
      inputString = inputString.replace(regex, replacement);
    }
  }
  // console.log(`replaceString - ${url}`, inputString)
  return inputString;
}

export function reverseReplaceString(inputString = '') {
  const authToken = JSON.parse(localStorage.getItem('User')) || {};
  if (process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken?.email) > -1) {
    // Iterate over each key-value pair in reReviseStringCode
    for (const [replacement, original] of Object.entries(reReviseStringCode)) {
      // Construct a regex pattern with the 'g' flag to replace all occurrences
      const regex = new RegExp(replacement, 'g');
      // Replace occurrences of the replacement string with the original string
      inputString = inputString.replace(regex, original);
    }
  }
  return inputString;
}

export function getRandomAsin() {
  // Static prefix
  const prefix = "B0";
  // Generate random alphanumeric characters (uppercase only)
  const randomString = Math.random().toString(36).substring(2, 10).toUpperCase();
  // Combine prefix and random string
  return prefix + randomString;
}


export function getRandomFSN() {
  // Static prefix
  const prefix = "SHOGTWF";
  // Generate random alphanumeric characters (uppercase only)
  const randomString = Math.random().toString(36).substring(2, 10).toUpperCase();
  // Combine prefix and random string
  return `${prefix}${randomString}`;
}

export const isDemoUser = () => {
  const authToken = JSON.parse(localStorage.getItem('User')) || {};
  return authToken?.email && process?.env?.REACT_APP_DEMO_EMAIL?.indexOf(authToken?.email) > -1;
}

export const generateRandomUrlForDemoUser =()=> {
  const demoImages = [
    "https://m.media-amazon.com/images/I/61cAYPHqiIL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/51S8l1usjyL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/71yYtqEQaKL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/81mSc0m54oL._SX695_.jpg",
    "https://m.media-amazon.com/images/I/613k0BK0YLL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/71Ogu5EshaL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/71NTqIWJNpL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/51P-L9v4rZL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/71Ie4D5qNaL._SY695_.jpg",
    "https://m.media-amazon.com/images/I/7185lGe0ppL._SY695_.jpg",
  ];

  const randomIndex = Math.floor(Math.random() * demoImages.length);
  return demoImages[randomIndex];
}